import { render, staticRenderFns } from "./TaskSummaryReportTable.vue?vue&type=template&id=45df4642&scoped=true&"
import script from "./TaskSummaryReportTable.vue?vue&type=script&lang=js&"
export * from "./TaskSummaryReportTable.vue?vue&type=script&lang=js&"
import style0 from "./TaskSummaryReportTable.vue?vue&type=style&index=0&id=45df4642&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../survey-planning.front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45df4642",
  null
  
)

export default component.exports